var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('app-bar'),_c('notifications'),_c('main-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }